import { useGtag } from "vue-gtag-next";
import { ref } from "vue";

export function useGooglePhoneConversion() {
    const { config } = useGtag();
    const phone = ref("");
    const phoneLink = ref("");

    function swapWithForwardingNumber(phoneNumber: string) {
        try {
            config({
                phone_conversion_number: phoneNumber,
                phone_conversion_callback: (
                    formattedNumber: string,
                    mobileNumber: string,
                ) => {
                    phone.value = formattedNumber;
                    phoneLink.value = `tel:${mobileNumber}`;
                },
            });
        } catch (error) {
            Bugsnag.notify(error);
        }
    }

    return {
        phone,
        phoneLink,
        swapWithForwardingNumber,
    };
}
